import React, { useState } from 'react';
import { MessageCircle } from 'lucide-react';
import { motion } from 'framer-motion';
import SEO from '../components/SEO';

// Static products data
const PRODUCTS_DATA = [
  // Dog Food
  {
    id: "1",
    name: "Royal Canin Adult Dog Food",
    category: "Dog Food",
    description: "Premium nutrition for adult dogs with balanced vitamins and minerals. Supports healthy digestion and shiny coat.",
    image: "https://images.unsplash.com/photo-1734654901149-02a9a5f7993b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxwZXQlMjBmb29kJTIwYm93bCUyMHN0YWlubGVzcyUyMHN0ZWVsJTIwY2VyYW1pY3xlbnwwfHx8fDE3NzI4OTAxMjF8MA&ixlib=rb-4.1.0&q=85",
    available: true
  },
  {
    id: "2",
    name: "Pedigree Complete Nutrition",
    category: "Dog Food",
    description: "Complete and balanced meal for dogs of all sizes. Rich in proteins for muscle development and energy.",
    image: "https://images.unsplash.com/photo-1679224106783-c21b1841412a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHxwZXQlMjBmb29kJTIwYm93bCUyMHN0YWlubGVzcyUyMHN0ZWVsJTIwY2VyYW1pY3xlbnwwfHx8fDE3NzI4OTAxMjF8MA&ixlib=rb-4.1.0&q=85",
    available: true
  },
  {
    id: "3",
    name: "Drools Focus Puppy Food",
    category: "Dog Food",
    description: "Specially formulated for puppies with DHA for brain development and calcium for strong bones.",
    image: "https://images.unsplash.com/photo-1741942732547-45a0d0c2b99a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwyfHxkb2clMjB0cmVhdHMlMjBiaXNjdWl0cyUyMHNuYWNrc3xlbnwwfHx8fDE3NzI4OTAxMDd8MA&ixlib=rb-4.1.0&q=85",
    available: true
  },
  // Dog Treats
  {
    id: "4",
    name: "Dental Chew Sticks",
    category: "Dog Treats",
    description: "Delicious dental treats that help clean teeth and freshen breath. Loved by dogs of all sizes.",
    image: "https://images.pexels.com/photos/13382042/pexels-photo-13382042.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    available: true
  },
  {
    id: "5",
    name: "Chicken Flavor Dog Biscuits",
    category: "Dog Treats",
    description: "Crunchy biscuits with real chicken flavor. Perfect for training rewards and healthy snacking.",
    image: "https://images.pexels.com/photos/8121142/pexels-photo-8121142.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    available: true
  },
  {
    id: "6",
    name: "Pedigree DentaStix",
    category: "Dog Treats",
    description: "Daily oral care treats that reduce tartar build-up by up to 80%. Clinically proven effective.",
    image: "https://images.unsplash.com/photo-1670855271692-07b283bf196f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHw0fHxkb2clMjB0cmVhdHMlMjBiaXNjdWl0cyUyMHNuYWNrc3xlbnwwfHx8fDE3NzI4OTAxMDd8MA&ixlib=rb-4.1.0&q=85",
    available: true
  },
  // Dog Toys
  {
    id: "7",
    name: "Interactive Ball Toy",
    category: "Dog Toys",
    description: "Durable rubber ball for fetch and play. Bouncy design keeps dogs entertained for hours.",
    image: "https://images.unsplash.com/photo-1764905087931-ae0fb3d1dcfb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxkb2clMjB0b3lzJTIwcnViYmVyJTIwYmFsbCUyMGNoZXclMjB0b3l8ZW58MHx8fHwxNzcyODkwMTEzfDA&ixlib=rb-4.1.0&q=85",
    available: true
  },
  {
    id: "8",
    name: "Squeaky Plush Toy",
    category: "Dog Toys",
    description: "Soft plush toy with built-in squeaker. Perfect for gentle play and cuddle time.",
    image: "https://images.unsplash.com/photo-1742865813209-c6a2d9b0ef07?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwzfHxkb2clMjB0b3lzJTIwcnViYmVyJTIwYmFsbCUyMGNoZXclMjB0b3l8ZW58MHx8fHwxNzcyODkwMTEzfDA&ixlib=rb-4.1.0&q=85",
    available: true
  },
  {
    id: "9",
    name: "Rope Tug Toy",
    category: "Dog Toys",
    description: "Strong cotton rope for tug-of-war games. Helps clean teeth while playing.",
    image: "https://images.unsplash.com/photo-1652990252875-22c8e25af948?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHw0fHxkb2clMjB0b3lzJTIwcnViYmVyJTIwYmFsbCUyMGNoZXclMjB0b3l8ZW58MHx8fHwxNzcyODkwMTEzfDA&ixlib=rb-4.1.0&q=85",
    available: true
  },
  // Dog Beds
  {
    id: "10",
    name: "Orthopedic Memory Foam Bed",
    category: "Dog Beds",
    description: "Premium memory foam bed for joint support. Ideal for senior dogs and large breeds.",
    image: "https://images.unsplash.com/photo-1610216165136-aa08162861d2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwyfHxkb2clMjBiZWQlMjBjdXNoaW9uJTIwcGV0JTIwc2xlZXBpbmd8ZW58MHx8fHwxNzcyODkwMTEzfDA&ixlib=rb-4.1.0&q=85",
    available: true
  },
  {
    id: "11",
    name: "Cozy Round Pet Cushion",
    category: "Dog Beds",
    description: "Soft and fluffy round bed perfect for small to medium dogs. Machine washable cover.",
    image: "https://images.unsplash.com/photo-1632147104665-09e9bf73703e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwzfHxkb2clMjBiZWQlMjBjdXNoaW9uJTIwcGV0JTIwc2xlZXBpbmd8ZW58MHx8fHwxNzcyODkwMTEzfDA&ixlib=rb-4.1.0&q=85",
    available: true
  },
  {
    id: "12",
    name: "Elevated Cooling Bed",
    category: "Dog Beds",
    description: "Raised mesh bed for better air circulation. Perfect for hot weather and outdoor use.",
    image: "https://images.unsplash.com/photo-1610216165697-73f2e46852f8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxkb2clMjBiZWQlMjBjdXNoaW9uJTIwcGV0JTIwc2xlZXBpbmd8ZW58MHx8fHwxNzcyODkwMTEzfDA&ixlib=rb-4.1.0&q=85",
    available: true
  },
  // Dog Collars & Leashes
  {
    id: "13",
    name: "Adjustable Nylon Collar",
    category: "Dog Collars & Leashes",
    description: "Durable nylon collar with quick-release buckle. Available in multiple colors and sizes.",
    image: "https://images.unsplash.com/photo-1592260368948-7789d2480b5a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHw0fHxkb2clMjBjb2xsYXIlMjBsZWFzaCUyMGhhcm5lc3MlMjB3YWxraW5nfGVufDB8fHx8MTc3Mjg5MDExNHww&ixlib=rb-4.1.0&q=85",
    available: true
  },
  {
    id: "14",
    name: "Retractable Dog Leash",
    category: "Dog Collars & Leashes",
    description: "16ft retractable leash with comfortable grip. One-button brake and lock system.",
    image: "https://images.unsplash.com/photo-1765895899115-bfdd2854b141?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxkb2clMjBjb2xsYXIlMjBsZWFzaCUyMGhhcm5lc3MlMjB3YWxraW5nfGVufDB8fHx8MTc3Mjg5MDExNHww&ixlib=rb-4.1.0&q=85",
    available: true
  },
  {
    id: "15",
    name: "No-Pull Dog Harness",
    category: "Dog Collars & Leashes",
    description: "Comfortable padded harness that prevents pulling. Easy to put on with adjustable straps.",
    image: "https://images.unsplash.com/photo-1762612037492-8c793c14a96c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwyfHxkb2clMjBjb2xsYXIlMjBsZWFzaCUyMGhhcm5lc3MlMjB3YWxraW5nfGVufDB8fHx8MTc3Mjg5MDExNHww&ixlib=rb-4.1.0&q=85",
    available: true
  },
  // Grooming Products
  {
    id: "16",
    name: "Pet Shampoo - Aloe Vera",
    category: "Grooming Products",
    description: "Gentle shampoo with aloe vera for sensitive skin. Leaves coat soft and shiny.",
    image: "https://images.unsplash.com/photo-1647002380358-fc70ed2f04e0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwxfHxkb2clMjBncm9vbWluZyUyMGJydXNoJTIwc2hhbXBvbyUyMGJhdGh8ZW58MHx8fHwxNzcyODkwMTIwfDA&ixlib=rb-4.1.0&q=85",
    available: true
  },
  {
    id: "17",
    name: "Slicker Brush for Dogs",
    category: "Grooming Products",
    description: "Professional-grade brush for removing tangles and loose fur. Suitable for all coat types.",
    image: "https://images.unsplash.com/photo-1597595735781-6a57fb8e3e3d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwyfHxkb2clMjBncm9vbWluZyUyMGJydXNoJTIwc2hhbXBvbyUyMGJhdGh8ZW58MHx8fHwxNzcyODkwMTIwfDA&ixlib=rb-4.1.0&q=85",
    available: true
  },
  {
    id: "18",
    name: "Complete Grooming Kit",
    category: "Grooming Products",
    description: "All-in-one grooming set with brush, comb, nail clipper, and scissors. Everything you need.",
    image: "https://images.unsplash.com/photo-1672426637977-1c84fb473464?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwzfHxkb2clMjBncm9vbWluZyUyMGJydXNoJTIwc2hhbXBvbyUyMGJhdGh8ZW58MHx8fHwxNzcyODkwMTIwfDA&ixlib=rb-4.1.0&q=85",
    available: true
  },
  // Pet Hygiene Products
  {
    id: "19",
    name: "Pet Wet Wipes - 80 Count",
    category: "Pet Hygiene Products",
    description: "Gentle cleaning wipes for paws, face, and body. Hypoallergenic and alcohol-free.",
    image: "https://images.unsplash.com/photo-1672426637959-49f39230ad7e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHw0fHxkb2clMjBncm9vbWluZyUyMGJydXNoJTIwc2hhbXBvbyUyMGJhdGh8ZW58MHx8fHwxNzcyODkwMTIwfDA&ixlib=rb-4.1.0&q=85",
    available: true
  },
  {
    id: "20",
    name: "Biodegradable Poop Bags",
    category: "Pet Hygiene Products",
    description: "Eco-friendly waste bags. Pack of 300 bags with dispenser. Leak-proof and durable.",
    image: "https://images.unsplash.com/photo-1765571475881-fdbd66fc7618?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwzfHxkb2clMjBjb2xsYXIlMjBsZWFzaCUyMGhhcm5lc3MlMjB3YWxraW5nfGVufDB8fHx8MTc3Mjg5MDExNHww&ixlib=rb-4.1.0&q=85",
    available: true
  },
  // Pet Accessories
  {
    id: "21",
    name: "Stainless Steel Food Bowl Set",
    category: "Pet Accessories",
    description: "Set of 2 non-slip stainless steel bowls. Rust-resistant and easy to clean.",
    image: "https://images.unsplash.com/photo-1743648774074-1b7fc8781180?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwzfHxwcmVtaXVtJTIwcGV0JTIwc3VwcGxpZXMlMjBkb2clMjBmb29kJTIwYWNjZXNzb3JpZXMlMjB0b3lzJTIwYm93bHMlMjBsZWFzaGVzfGVufDB8fHx8MTc3Mjg5MDEwMXww&ixlib=rb-4.1.0&q=85",
    available: true
  },
  {
    id: "22",
    name: "Pet Carrier Bag",
    category: "Pet Accessories",
    description: "Airline-approved soft carrier with ventilation. Comfortable for travel and vet visits.",
    image: "https://images.unsplash.com/photo-1743648773958-0715973a12d5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHw0fHxwcmVtaXVtJTIwcGV0JTIwc3VwcGxpZXMlMjBkb2clMjBmb29kJTIwYWNjZXNzb3JpZXMlMjB0b3lzJTIwYm93bHMlMjBsZWFzaGVzfGVufDB8fHx8MTc3Mjg5MDEwMXww&ixlib=rb-4.1.0&q=85",
    available: true
  },
  {
    id: "23",
    name: "Automatic Water Fountain",
    category: "Pet Accessories",
    description: "Fresh flowing water fountain encourages hydration. Includes replaceable filter.",
    image: "https://images.unsplash.com/photo-1672323471087-3c6c76ebd4c1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwyfHxwcmVtaXVtJTIwcGV0JTIwc3VwcGxpZXMlMjBkb2clMjBmb29kJTIwYWNjZXNzb3JpZXMlMjB0b3lzJTIwYm93bHMlMjBsZWFzaGVzfGVufDB8fHx8MTc3Mjg5MDEwMXww&ixlib=rb-4.1.0&q=85",
    available: true
  }
];

const Supplies = () => {
  const [products] = useState(PRODUCTS_DATA);
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [loading] = useState(false);

  const categories = [
    'All',
    'Dog Food',
    'Dog Treats',
    'Dog Toys',
    'Dog Beds',
    'Dog Collars & Leashes',
    'Grooming Products',
    'Pet Hygiene Products',
    'Pet Accessories'
  ];

  const filteredProducts =
    selectedCategory === 'All'
      ? products
      : products.filter((p) => p.category === selectedCategory);

  const handleInquiry = (productName) => {
    const message = `Hello, I want to know about ${productName}. Is it available at your store?`;
    window.open(`https://wa.me/917217648679?text=${encodeURIComponent(message)}`, '_blank');
  };

  return (
    <div data-testid="supplies-page" style={{ backgroundColor: 'var(--neutral-bg)', minHeight: '100vh' }}>
      <SEO />
      {/* Hero Section */}
      <section
        className="py-20"
        style={{
          background: 'linear-gradient(to bottom right, #FEF3C7, #FFFFFF)',
          borderBottom: '1px solid var(--neutral-border)'
        }}
      >
        <div className="container mx-auto text-center">
          <h1 className="text-4xl sm:text-5xl font-bold mb-4" style={{ color: 'var(--text-main)' }}>
            Pet Supplies
          </h1>
          <p className="text-lg" style={{ color: 'var(--text-muted)' }}>
            Everything your pet needs - premium quality supplies for happy, healthy pets
          </p>
        </div>
      </section>

      {/* Category Filter */}
      <section className="py-8" style={{ backgroundColor: 'white', position: 'sticky', top: '72px', zIndex: 10 }}>
        <div className="container mx-auto">
          <div className="flex gap-3 overflow-x-auto pb-2" style={{ scrollbarWidth: 'thin' }}>
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                data-testid={`category-${category.toLowerCase().replace(/\s+/g, '-')}`}
                className="transition-all"
                style={{
                  padding: '0.75rem 1.5rem',
                  borderRadius: '9999px',
                  fontWeight: '600',
                  fontSize: '0.875rem',
                  whiteSpace: 'nowrap',
                  border: selectedCategory === category ? 'none' : '2px solid var(--neutral-border)',
                  backgroundColor:
                    selectedCategory === category ? 'var(--primary-main)' : 'white',
                  color: selectedCategory === category ? 'white' : 'var(--text-main)',
                  cursor: 'pointer'
                }}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Products Grid */}
      <section className="py-16">
        <div className="container mx-auto">
          {loading ? (
            <div className="text-center py-20">
              <p style={{ color: 'var(--text-muted)' }}>Loading supplies...</p>
            </div>
          ) : filteredProducts.length === 0 ? (
            <div className="text-center py-20">
              <p style={{ color: 'var(--text-muted)' }}>No products found in this category.</p>
            </div>
          ) : (
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="supplies-list">
              {filteredProducts.map((product, index) => (
                <motion.div
                  key={product.id}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  className="shadow-soft transition-all hover:shadow-xl group"
                  style={{
                    backgroundColor: 'white',
                    borderRadius: '1.5rem',
                    overflow: 'hidden'
                  }}
                >
                  <div style={{ position: 'relative', overflow: 'hidden' }}>
                    <img
                      src={product.image}
                      alt={product.name}
                      style={{
                        width: '100%',
                        height: '240px',
                        objectFit: 'cover',
                        transition: 'transform 0.3s ease'
                      }}
                      className="group-hover:scale-110"
                    />
                  </div>
                  <div style={{ padding: '1.5rem' }}>
                    <div
                      className="inline-block px-3 py-1 rounded-full text-xs font-semibold mb-3"
                      style={{
                        backgroundColor: 'var(--secondary-light)',
                        color: 'var(--secondary-dark)'
                      }}
                    >
                      {product.category}
                    </div>
                    <h3 className="text-xl font-bold mb-2" style={{ color: 'var(--text-main)' }}>
                      {product.name}
                    </h3>
                    <p className="text-sm mb-4" style={{ color: 'var(--text-muted)' }}>
                      {product.description}
                    </p>
                    <button
                      onClick={() => handleInquiry(product.name)}
                      data-testid={`inquire-product-${product.id}`}
                      className="w-full transition-all hover:-translate-y-1 flex items-center justify-center gap-2"
                      style={{
                        backgroundColor: 'var(--primary-main)',
                        color: 'white',
                        padding: '0.75rem',
                        borderRadius: '0.75rem',
                        fontWeight: 'bold',
                        border: 'none',
                        cursor: 'pointer'
                      }}
                    >
                      <MessageCircle size={18} />
                      Inquire on WhatsApp
                    </button>
                  </div>
                </motion.div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* Trust Badges Section */}
      <section className="py-16" style={{ backgroundColor: 'white' }}>
        <div className="container mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            <div className="text-center">
              <div
                className="inline-flex items-center justify-center mb-3"
                style={{
                  width: '60px',
                  height: '60px',
                  backgroundColor: 'var(--accent-light)',
                  borderRadius: '50%',
                  fontSize: '1.5rem'
                }}
              >
                ✔
              </div>
              <h4 className="font-bold text-sm" style={{ color: 'var(--text-main)' }}>
                Quality Products
              </h4>
            </div>
            <div className="text-center">
              <div
                className="inline-flex items-center justify-center mb-3"
                style={{
                  width: '60px',
                  height: '60px',
                  backgroundColor: 'var(--primary-light)',
                  borderRadius: '50%',
                  fontSize: '1.5rem'
                }}
              >
                ✔
              </div>
              <h4 className="font-bold text-sm" style={{ color: 'var(--text-main)' }}>
                Affordable Pricing
              </h4>
            </div>
            <div className="text-center">
              <div
                className="inline-flex items-center justify-center mb-3"
                style={{
                  width: '60px',
                  height: '60px',
                  backgroundColor: 'var(--secondary-light)',
                  borderRadius: '50%',
                  fontSize: '1.5rem'
                }}
              >
                ✔
              </div>
              <h4 className="font-bold text-sm" style={{ color: 'var(--text-main)' }}>
                Trusted Brands
              </h4>
            </div>
            <div className="text-center">
              <div
                className="inline-flex items-center justify-center mb-3"
                style={{
                  width: '60px',
                  height: '60px',
                  backgroundColor: 'var(--accent-light)',
                  borderRadius: '50%',
                  fontSize: '1.5rem'
                }}
              >
                ✔
              </div>
              <h4 className="font-bold text-sm" style={{ color: 'var(--text-main)' }}>
                Expert Guidance
              </h4>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Supplies;
